import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("auth.login.errors.invalid")
    .required("auth.login.errors.required"),
  password: yup.string().required("auth.login.errors.required"),
});

export const passwordValidation = yup.object().shape({
  password: yup.string().required("Required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Required"),
});
